export const [DEV, QA, PREPROD, PROD] = ["DEV", "QA", "PREPROD", "PROD"]
export const getCurrentEnv = (hostname: string): string => {
  const envs = {
    "localhost": "DEV",
    "ui.lendex-lendex-dev.aws.svbank.com": "DEV",
    "ui.lendex-lendex-qa.aws.svbank.com": "QA",
    "lendx.uat.svb.com": "PREPROD",
    "lendx.svb.com": "PROD"
  }
  return envs[hostname]?? "PROD";
}
